import moment from "moment";

export const cloneJsaActivities = (sourceActivities = []) => (
  sourceActivities.map((activity) => ({
    ...activity,
    fm_swms_actions_v2: Array.isArray(activity && activity.fm_swms_actions_v2)
      ? activity.fm_swms_actions_v2.map((action) => ({
        ...action,
        fm_swms_activities_hazards_v2: Array.isArray(action && action.fm_swms_activities_hazards_v2)
          ? action.fm_swms_activities_hazards_v2.map((hazard) => ({
            ...hazard,
            fm_swms_hazards_consequences_v2: Array.isArray(hazard && hazard.fm_swms_hazards_consequences_v2)
              ? hazard.fm_swms_hazards_consequences_v2.map((consequence) => ({ ...consequence }))
              : []
          }))
          : []
      }))
      : []
  }))
);

export const markActivityEdited = (updated, actIndex, user, userName) => {
  if (!updated[actIndex]) {
    return updated;
  }

  updated[actIndex].edited = true;
  updated[actIndex].modified_by = user ? user.user_name : null;
  updated[actIndex].modified_by_name = userName;
  updated[actIndex].modified_at = moment.utc().toISOString();

  return updated;
};

export const resolveSwmsTitle = (swmsData) => {
  if (
    swmsData
    && swmsData.sections
    && swmsData.sections.document_project_details
    && swmsData.sections.document_project_details.data
    && typeof swmsData.sections.document_project_details.data.swms_name === "string"
  ) {
    return swmsData.sections.document_project_details.data.swms_name;
  }

  return swmsData && swmsData.title ? swmsData.title : "";
};

export const buildJsaFormData = (swmsData, activitiesData) => ({
  title: resolveSwmsTitle(swmsData),
  document: {
    meta: swmsData.meta,
    sections: {
      ...swmsData.sections,
      job_steps_hazards_consequences_controls: {
        ...swmsData.sections.job_steps_hazards_consequences_controls,
        data: {
          toggle: 1,
          activities: activitiesData
        }
      }
    }
  }
});

export const decorateActivitiesWithRiskColors = (activities = [], risks = []) => (
  activities.map((activity) => {
    const actions = Array.isArray(activity && activity.fm_swms_actions_v2)
      ? activity.fm_swms_actions_v2.map((action) => {
        const irRisk = action.initial_risk
          ? risks.find((risk) => risk.risk_rating_high_value >= action.initial_risk && risk.risk_rating_low_value <= action.initial_risk)
          : null;
        const rrRisk = action.residual_risk
          ? risks.find((risk) => risk.risk_rating_high_value >= action.residual_risk && risk.risk_rating_low_value <= action.residual_risk)
          : null;

        return {
          ...action,
          irRisk: irRisk ? irRisk.risk_colours : "",
          rrRisk: rrRisk ? rrRisk.risk_colours : ""
        };
      })
      : [];

    return {
      ...activity,
      fm_swms_actions_v2: actions
    };
  })
);
